var _desc, _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChevron(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "6px",
    height: "10px",
    viewBox: "0 0 6 10",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Chevron") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Symbols",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Chevron",
    transform: "translate(-4.000000, 0.000000)",
    fill: "#848484"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.94974747,8.44974747 L1.94974747,8.44974747 C1.67360509,8.44974747 1.44974747,8.22588984 1.44974747,7.94974747 C1.44974747,7.67360509 1.67360509,7.44974747 1.94974747,7.44974747 L7.44974747,7.44974747 L7.44974747,1.94974747 C7.44974747,1.67360509 7.67360509,1.44974747 7.94974747,1.44974747 C8.22588984,1.44974747 8.44974747,1.67360509 8.44974747,1.94974747 L8.44974747,7.94974747 C8.44974747,8.22588984 8.22588984,8.44974747 7.94974747,8.44974747 Z",
    transform: "translate(4.949747, 4.949747) rotate(-45.000000) translate(-4.949747, -4.949747) "
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevron);
export default __webpack_public_path__ + "static/media/Chevron.1b4c545c38d8bbea4738a461189b928b.svg";
export { ForwardRef as ReactComponent };